import { nanoid } from "nanoid";
import { useBoundStore } from "@maxis/client-logic/store/useBoundStore";

export default function useMessageBox() {
  // get `actions` from the store
  const pushMessage = useBoundStore((s) => s.messageBox.pushMessage);
  const popMessage = useBoundStore((s) => s.messageBox.popMessage);

  const confirm = (title, description = "", time = 0) =>
    new Promise((resolve) => {
      const id = nanoid();
      pushMessage({
        id,
        type: "confirm",
        title,
        description,
        time,
        responseHandler: resolve,
      });
    });

  const alert = (title, description = "", time = 0) =>
    new Promise((resolve) => {
      const id = nanoid();
      pushMessage({
        id,
        type: "alert",
        title,
        description,
        time,
        responseHandler: resolve,
      });
    });

  const error = (title, description = "", time = 0) =>
    new Promise((resolve) => {
      const id = nanoid();
      pushMessage({
        id,
        type: "error",
        title,
        description,
        time,
        responseHandler: resolve,
      });
    });

  const prompt = (title, description = "", time = 0) =>
    new Promise((resolve) => {
      const id = nanoid();
      pushMessage({
        id,
        type: "prompt",
        title,
        description,
        time,
        responseHandler: resolve,
      });
    });

  return {
    confirm,
    alert,
    error,
    prompt,
    popMessage, // MessageBox 컴포넌트에서 사용
  };
}
